import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AddressDataForm } from '../_models/address-data-form';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  percentDone: number;
  uploadSuccess: boolean;

 
    constructor(private http: HttpClient, private authService : AuthService) { }
    public static readonly URL_ADDRESS_CONTROLLER = environment.apiUrl + '/address/';
  
    public static readonly URL_ADDRESS_LIST = AddressService.URL_ADDRESS_CONTROLLER + "all/";
    public static readonly URL_ADDRESS_BY_ID = AddressService.URL_ADDRESS_CONTROLLER + "getById/";
    public static readonly URL_SAVE_AND_UPDATE_ADDRESS = AddressService.URL_ADDRESS_CONTROLLER + "saveUpdate/";
    public static readonly URL_ADDRESS_DETAILS_BY_USER_ID = AddressService.URL_ADDRESS_CONTROLLER + "getAddressByUserId/";

  
  
    getAddressList() {
      let userToken: string = this.authService.getUserToken();
      return this.http.get(AddressService.URL_ADDRESS_LIST + "/" + userToken,)
       .pipe(catchError(this.handleError('Request Failed')));
    }
    
    getAddressId(id) {
      let userToken: string = this.authService.getUserToken();
      return this.http.post(AddressService.URL_ADDRESS_BY_ID +id + '/'+userToken,id)
        .pipe(catchError(this.handleError('Request Failed')));
    }

    getAddressByUserId(id)
    {
      let userToken: string = this.authService.getUserToken();
      return this.http.post(AddressService.URL_ADDRESS_DETAILS_BY_USER_ID +id + '/'+userToken,id)
        .pipe(catchError(this.handleError('Request Failed')));
    }
    saveAddress(addressDataForm: AddressDataForm) {
      let userToken: string = this.authService.getUserToken();
      return this.http.post(AddressService.URL_SAVE_AND_UPDATE_ADDRESS + userToken,addressDataForm)
        .pipe(catchError(this.handleError('Request Failed')));
    }

    // uploadAndProgress(files: File[]){
      
    //   console.log(files)
    //   var formData = new FormData();
    //   Array.from(files).forEach(f => 
        
    //     formData.append('file',f))
    //   this.http.post('https://file.io', formData, {reportProgress: true, observe: 'events'})
    //     .subscribe(event => {
    //       if (event.type === HttpEventType.UploadProgress) {
    //         this.percentDone = Math.round(100 * event.loaded / event.total);
    //       } else if (event instanceof HttpResponse) {
    //         this.uploadSuccess = true;
    //       }
    //   });
    // }
    private handleError<T>(operation = 'operation', result?: T) {
      return (error: HttpErrorResponse) => {
        console.log(error);
        if (error.status === 401) {
          localStorage.removeItem('currentUser');
          window.location.replace('');
        }
        return Observable.throw(error);
      };
    }
  }
  
  
